'use strict';
var info = null;
var addedClasses = false;

function getInfo() {
	if (info === null) {
		var ua = navigator.userAgent;

		info = {};

		info.android = /android\s(\d)/ig.test(ua) && !/(chrome|iemobile)/ig.test(ua);
		if (info.android) {
			info.androidInfo = {};
			info.androidInfo.versionOs = /[\d\.]+/.exec(/android\s[\d\.]*/ig.exec(ua));
			info.androidInfo.versionBrowser = /[\d\.]+/.exec(/version\/.*\s/ig.exec(ua));
		}

		info.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		info.webkit = !!ua.match(/WebKit/i);
		info.iOSSafari = info.iOS && info.webkit && !ua.match(/CriOS/i);
	}
	return info;
}

function addStyleClasses() {
	if (addedClasses){
		return;
	}
	var info = getInfo();

	var addClasses = [];


	if (info.android) {
		document.documentElement.setAttribute('data-os', 'android '+info.androidInfo.versionOs);
		document.documentElement.setAttribute('data-browser', 'android '+info.androidInfo.versionBrowser);
	}
	if (info.iOSSafari) {
		document.documentElement.setAttribute('data-os', 'iOS');
		document.documentElement.setAttribute('data-browser', 'Safari');
	}
	if (addClasses.length > 0) {
		document.documentElement.className += ' ' + addClasses.join(' ');
	}
	addedClasses = true;
}

module.exports = {
	getInfo: getInfo,
	addStyleClasses: addStyleClasses
};